import Papa from 'papaparse';

// Mirrors backend's toTitleCase in EQID-Backend/controller/assemblyController.js
export function toTitleCase(str) {
  if (!str) return '';
  return str
    .split(/\s+/)
    .filter((word) => word.length > 0)
    .map((word) => (word === word.toUpperCase() ? word : word[0].toUpperCase() + word.slice(1).toLowerCase()))
    .join(' ');
}

export function parseCsvFile(file) {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      transformHeader: (header) => header.trim(),
      complete: (results) => resolve(results),
      error: (error) => reject(error),
    });
  });
}

// Backend requires the "Machine Series" header, and each row needs at least
// one of Model Number / Assembly # to avoid being silently skipped.
export function validateCsvHeaders(fields = []) {
  const errors = [];
  if (!fields.includes('Machine Series')) {
    errors.push('Missing required column "Machine Series".');
  }
  if (!fields.includes('Model Number') && !fields.includes('Assembly #')) {
    errors.push('CSV must include a "Model Number" or "Assembly #" column.');
  }
  return errors;
}

export function getRowValidationErrors(row) {
  const errors = [];
  if (!row['Model Number']?.trim() && !row['Assembly #']?.trim()) {
    errors.push('Missing both Model Number and Assembly #');
  }
  return errors;
}

// Reproduces the field mapping bulkUpload() applies per row in
// EQID-Backend/controller/assemblyController.js, for preview purposes.
export function mapCsvRow(row) {
  const manuals = [];
  for (let i = 1; i <= 3; i++) {
    const value = row[`Operations Manual #${i}`]?.trim();
    if (value) manuals.push(`${value}.pdf`);
  }

  const videos = [];
  for (let i = 1; i <= 10; i++) {
    const value = row[`Tutorial Video #${i}`]?.trim();
    if (value) videos.push(value);
  }

  const embeddedAssemblies = [];
  for (let i = 1; i <= 8; i++) {
    const value = row[`Embebbed Assembly #${i}`]?.trim();
    if (value) embeddedAssemblies.push(value);
  }

  const electricalSchematics = [];
  for (let i = 1; i <= 3; i++) {
    const value = row[`Electrical Schematic ${i}`]?.trim();
    if (value) electricalSchematics.push(value);
  }

  const series = (row['Machine Series'] || '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);

  return {
    model_number: row['Model Number']?.trim() || '',
    model_description: row['Model Description']?.trim() || '',
    assembly_number: row['Assembly #']?.trim() || '',
    assembly_description: row['Assembly Description']?.trim() || '',
    assembly_type: toTitleCase(row['Assembly Type']?.trim() || 'Other Assembly'),
    series,
    manuals,
    videos,
    embeddedAssemblies,
    electricalSchematics,
    pneumaticSchematic: row['Pneumatic Schematic']?.trim() || '',
  };
}

export function buildCsvPreview(parseResults) {
  const fields = parseResults.meta?.fields || [];
  const headerErrors = validateCsvHeaders(fields);
  const rows = (parseResults.data || []).map((row) => ({
    mapped: mapCsvRow(row),
    errors: getRowValidationErrors(row),
  }));

  return { fields, headerErrors, rows };
}
